/* eslint-disable jsx-a11y/label-has-associated-control */
import { useRef, useState } from "react"
import { useIntl } from "react-intl"

import { ICONS, StaffLabelTextS } from "@doktor-se/bones-ui"
import { useClickOutside } from "@doktor-se/bones-ui/dist/web-shared/hooks"

import styles from "./FilterDropdown.module.scss"

export type FilterOption = {
  label: string
  value: string
}

interface FilterDropdownProps {
  options: FilterOption[]
  selected: FilterOption
  onChange: (option: FilterOption) => void
}

const FilterDropdown = ({ options, selected, onChange }: FilterDropdownProps) => {
  const intl = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef(null)
  useClickOutside(containerRef, () => setIsOpen(false))

  const toggle = () => setIsOpen(prev => !prev)

  return (
    <div className={styles.dropdown} ref={containerRef}>
      <button onClick={toggle} className={styles.button}>
        <ICONS.Sort />
        <StaffLabelTextS>{`${intl.formatMessage({ id: "label.reassign.sort_by" })}: ${intl.formatMessage({ id: selected.label })}`}</StaffLabelTextS>
      </button>

      {isOpen && (
        <div className={styles.menu}>
          {options.map(option => (
            <label key={option.value} className={styles.option}>
              <span>{intl.formatMessage({ id: option.label })}</span>
              <input
                id={`filter-${option.value}`}
                type="radio"
                name="filter"
                value={option.value}
                checked={selected.value === option.value}
                className={styles.radioInput}
                onChange={() => {
                  onChange(option)
                  setIsOpen(false)
                }}
              />
              <label htmlFor={`filter-${option.value}`} className={styles.dot} />
            </label>
          ))}
        </div>
      )}
    </div>
  )
}

export default FilterDropdown
